import React from 'react';

const TermsOfService: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <div className="max-w-4xl mx-auto px-6 py-10 space-y-8">
        <div>
          <h1 className="text-3xl font-bold font-poppins text-[#1A1A1A]">Terms of Service</h1>
          <p className="text-sm text-[#777777] mt-2">Last updated: May 8, 2026</p>
        </div>

        <section className="bg-white border border-[#E8E8E8] rounded-lg p-6 space-y-4 text-[#333333] text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-[#1A1A1A]">1. Agreement to Terms</h2>
          <p>
            These Terms of Service govern access to and use of Kipr, including web applications, voice training tools, analytics,
            and related services. By using Kipr, you agree to be bound by these terms.
          </p>
          <p>
            If you use Kipr on behalf of an organization, you represent that you have authority to bind that organization to these terms.
          </p>
        </section>

        <section className="bg-white border border-[#E8E8E8] rounded-lg p-6 space-y-4 text-[#333333] text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-[#1A1A1A]">2. Service Scope</h2>
          <p>
            Kipr provides simulated training conversations and performance feedback for educational and professional development purposes.
            Kipr is not a medical device and does not provide diagnosis, treatment, or legal advice.
          </p>
          <p>
            You remain solely responsible for clinical judgment, compliance obligations, and any professional decisions made outside the platform.
          </p>
        </section>

        <section className="bg-white border border-[#E8E8E8] rounded-lg p-6 space-y-4 text-[#333333] text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-[#1A1A1A]">3. Account Responsibilities</h2>
          <p>You must provide accurate information, keep credentials secure, and notify us of suspected unauthorized access.</p>
          <p>You are responsible for all activity performed through your account.</p>
        </section>

        <section className="bg-white border border-[#E8E8E8] rounded-lg p-6 space-y-4 text-[#333333] text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-[#1A1A1A]">4. Acceptable Use</h2>
          <p>You agree not to misuse the service, including by attempting to disrupt infrastructure, scrape protected data, or bypass access controls.</p>
          <p>You must not upload or submit content that violates applicable laws, third-party rights, or confidentiality obligations.</p>
        </section>

        <section className="bg-white border border-[#E8E8E8] rounded-lg p-6 space-y-4 text-[#333333] text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-[#1A1A1A]">5. Billing and Subscriptions</h2>
          <p>
            Paid features are offered on a subscription basis and billed through Stripe. Subscription status, renewals, and cancellations
            are managed in the billing portal.
          </p>
          <p>
            The standard plan is $39 per month and includes up to 3 training hours per billing month. Additional training hours are billed
            at $10 per hour.
          </p>
          <p>
            Included and purchased training hours expire at the end of each billing month and do not roll over into future billing periods.
          </p>
          <p>
            Unless required by law, fees are non-refundable. You authorize us and our payment processor to charge applicable recurring fees
            until cancellation.
          </p>
        </section>

        <section className="bg-white border border-[#E8E8E8] rounded-lg p-6 space-y-4 text-[#333333] text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-[#1A1A1A]">6. Data and Content</h2>
          <p>
            You retain rights to content you submit. You grant Kipr a limited license to process submitted content for service operation,
            quality, safety, and support.
          </p>
          <p>
            You must not submit protected health information or personal data beyond what you are permitted to process under your own policies
            and applicable law.
          </p>
        </section>

        <section className="bg-white border border-[#E8E8E8] rounded-lg p-6 space-y-4 text-[#333333] text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-[#1A1A1A]">7. Intellectual Property</h2>
          <p>
            Kipr and its software, branding, and documentation are owned by Kipr and licensors. Except as expressly permitted, no rights are
            granted to copy, modify, or redistribute service materials.
          </p>
        </section>

        <section className="bg-white border border-[#E8E8E8] rounded-lg p-6 space-y-4 text-[#333333] text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-[#1A1A1A]">8. Availability and Changes</h2>
          <p>
            We may update or discontinue features at any time. We do not guarantee uninterrupted service, specific feature availability,
            or error-free operation.
          </p>
        </section>

        <section className="bg-white border border-[#E8E8E8] rounded-lg p-6 space-y-4 text-[#333333] text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-[#1A1A1A]">9. Disclaimer and Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, Kipr is provided &quot;as is&quot; and without warranties of any kind. We disclaim implied
            warranties of merchantability, fitness for a particular purpose, and non-infringement.
          </p>
          <p>
            To the maximum extent permitted by law, Kipr will not be liable for indirect, incidental, special, consequential, or punitive damages.
          </p>
        </section>

        <section className="bg-white border border-[#E8E8E8] rounded-lg p-6 space-y-4 text-[#333333] text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-[#1A1A1A]">10. Termination</h2>
          <p>We may suspend or terminate accounts for violations of these terms or security/safety reasons.</p>
          <p>You may stop using Kipr at any time and cancel subscriptions through the billing portal.</p>
        </section>

        <section className="bg-white border border-[#E8E8E8] rounded-lg p-6 space-y-4 text-[#333333] text-sm leading-relaxed">
          <h2 className="text-xl font-semibold text-[#1A1A1A]">11. Contact</h2>
          <p>Questions about these terms can be sent to support@kipr.app.</p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;
